import { ROLES } from './enums/roles';

const {
  anetarShm,
  anetarKlgj,
  anetarKlp,
  specialistFF,
  admin,
  pedagog,
  anetarAsh,
  kancelar,
} = ROLES;

export const allAnetarKomisioni: ROLES[] = [
  anetarShm,
  anetarKlgj,
  anetarKlp,
  anetarAsh,
];

export const allFormimiFillestar: ROLES[] = [
  specialistFF,
  admin,
  pedagog,
  kancelar,
];
